import { Route, Routes } from "react-router";
import MenuPage from "./pages/MenuPage";
import LinkPresentation from "./vcard/pages/LinkPresentation";

function App() {
  return (
    <Routes>
      <Route path="/" element={<MenuPage />} />
      <Route path="contact" element={<LinkPresentation />} />
    </Routes>
  );
}

export default App;
